import Markdown from 'react-markdown';

import { cn } from '~/lib/cn';

import type { ChatMessage } from '../hooks/useMusicIqChatbot';

interface MessageBubbleProps {
  message: ChatMessage;
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === 'user';

  return (
    <div
      className={cn('flex w-full', isUser ? 'justify-end' : 'justify-start')}
    >
      <div
        className={cn(
          'max-w-[80%] rounded-lg px-md py-sm',
          isUser
            ? 'bg-primary-default text-strong-on-dark'
            : 'bg-emphasis-strong text-strong',
        )}
      >
        {isUser ? (
          <p className="whitespace-pre-wrap text-body-sm">{message.content}</p>
        ) : (
          <Markdown
          // @TODO WMG1-908 - Figure out styling here...
          // className={cn(
          //   'text-body-sm',
          //   '[&_p:last-child]:mb-0 [&_p]:mb-md',
          //   '[&_ul]:mb-md [&_ul]:list-disc [&_ul]:pl-lg',
          //   '[&_ol]:mb-md [&_ol]:list-decimal [&_ol]:pl-lg',
          //   '[&_li]:mb-xs',
          //   '[&_h1]:text-heading-lg [&_h1]:mb-md [&_h1]:font-bold',
          //   '[&_h2]:text-heading-md [&_h2]:mb-md [&_h2]:font-bold',
          //   '[&_h3]:text-heading-sm [&_h3]:mb-sm [&_h3]:font-bold',
          //   '[&_code]:rounded-xs [&_code]:px-xs [&_code]:bg-emphasis-subtle',
          //   '[&_pre]:mb-md [&_pre]:overflow-x-auto [&_pre]:rounded-sm [&_pre]:p-md [&_pre]:bg-emphasis-subtle',
          //   '[&_a]:underline [&_a]:text-secondary-default',
          //   '[&_blockquote]:border-l-2 [&_blockquote]:pl-md [&_blockquote]:italic [&_blockquote]:border-emphasis-subtle',
          // )}
          >
            {message.content}
          </Markdown>
        )}
      </div>
    </div>
  );
}

MessageBubble.displayName = 'MessageBubble';
